import { UAT_ENV } from "../config";

export const APP_PATH = UAT_ENV ? "/home" : "/home";

export const routePath = {
  landingpage: {
    path: `/mykare`,
  },
  home: {
    path: `${APP_PATH}`,
  },
  aboutus: {
    path: `${APP_PATH}/aboutus`,
  },
  resources: {
    path: `${APP_PATH}/resources`,
    child: {
      blog: "/blog",
      newsletter: "/newsletter",
      casestudy: "/casestudy",
      ebook: "/ebook",
      videos: "/videos",
      webinars: "/webinars",
      contactus: "/contactus",
    },
  },
  oursolutions: {
    path: `${APP_PATH}/oursolutions`,
    child: {
      bfsi: "/bfsi",
      hospitality: "/hospitality",
      retail: "/retail",
      dthentertainment: "/dthentertainment",
      realestate: "/realestate",
      education: "/education",
      contactus: "/contactus",
    },
  },
  channels: {
    path: `${APP_PATH}/channels`,
    child: {
      sms: "/sms",
      googlercs: "/googlercs",
      whatsapp: "/whatsapp",
      email: "/email",
      voiceapis: "/voiceapis",
      contactus: "/contactus",
    },
  },
  subscription: {
    path: `${APP_PATH}/subscription`,
    child: {
      freetrialform: `/form`,
    },
  },
  termsofservice: {
    path: `${APP_PATH}/termsofservice`,
  },
  privacypolicy: {
    path: `${APP_PATH}/privacypolicy`,
  },
  thankyou: {
    path: `${APP_PATH}/thankyou`,
  },
  invalid: "*",
};
